import {sharedCampaigns} from '@cl/shared';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTSequenceNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';

function createDefaultSequenceCard(): DTSequenceNode {
  return {
    id: NO_NODE_ID,
    name: 'Sequence Card',
    description: '',
    type: NodeType.SEQUENCE,
    x: 0,
    y: 0,
    maxRepeats: null,
    outputs: [
      {
        id: 1,
        name: 'Output 1',
        type: OutputType.Regular,
        maxRepeats: 1,
        nodeId: NO_NODE_ID,
      },
      {
        id: 2,
        name: 'Fallback',
        type: OutputType.Fallback,
        nodeId: NO_NODE_ID,
      },
    ],
    inputs: [],
  };
}

function ensureFallbackOutputExists(card: DTSequenceNode): void {
  const hasFallback = card.outputs.some((output) => output.type === OutputType.Fallback);

  if (!hasFallback) {
    const nextId = card.outputs.length > 0 ? Math.max(...card.outputs.map((o) => o.id), 0) + 1 : 1;

    card.outputs.push({
      id: nextId,
      name: 'Fallback',
      type: OutputType.Fallback,
      nodeId: NO_NODE_ID,
    });
  }
}

/**
 * Gets an existing sequence card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0 for a new card
 * @returns The sequence card (existing or new), fully mutable
 */
async function getOrCreateSequenceCard(cardId: number, _store: CLStore): Promise<DTSequenceNode> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId];

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    if (existingCard.type !== NodeType.SEQUENCE) {
      throw new Error(`Card with id ${resolvedCardId} is not a sequence card`);
    }

    ensureFallbackOutputExists(existingCard as DTSequenceNode);

    return existingCard as DTSequenceNode;
  }

  return createDefaultSequenceCard();
}

export default getOrCreateSequenceCard;
export {createDefaultSequenceCard};
